import React, { Component } from 'react'
import { Layout } from 'antd';
import '../../../App.css'
import './index.css'
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom'
import srimg from '../../../assets/images/service-rights.png'
const { Content, Sider } = Layout;
let isCN ;
//台湾:es-ygj.digiwincloud.com
 if(window.location.host === 'es-ygj.digiwincloud.com.cn' || window.location.host === 'localhost:3000'){
     isCN = true
 }else{
   isCN = false
 }
class ServiceRights extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { t } = this.props;
        if (!isCN) {
            return  <Redirect from="*" to="/404" />;
        }else{
            return (
            <Content className="q-content-wrapper">
             <div  className="servie-right-bg">
                <img src={srimg} />
             </div>
            </Content>
            )
        }
        
    }
}
export default withTranslation()(ServiceRights)